module.exports = __webpack_public_path__ + "img/audit.6c817210.png";